module.exports = __webpack_public_path__ + "static/media/car10.bed197ed.png";